module.exports = __webpack_public_path__ + "static/media/glass-curtain.aa1646f0.png";